import {
  faWarehouse,
  faGlobe,
  faDrawPolygon,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";

export const serviceLines = [
  {
    id: 1,
    icon: faWarehouse,
    title: "One-Stop Destination for all Concrete Requirements",
    body: "We offer premium quality pump spares, industrial pumps and related accessories in accordance with international market standards. These parts are available for all concreting requirements at affordable rates.",
  },
  {
    id: 2,
    icon: faGlobe,
    title: "Worldwide Sourcing Partner",
    body: "We act as a procurement service provider for companies across the globe, with expertise in forging, casting and machining. Our regional presence in India lets us address sourcing risks directly and deliver results to your bottom line.",
  },
  {
    id: 3,
    icon: faDrawPolygon,
    title: "Consultancy for Custom Pumps and Layout",
    body: "Our team of spare technicians provides expert assistance in choosing the right pumps and layout for your specific application, so you get high-efficiency, reliable pump operation without paying for capacity you will never use.",
  },
  {
    id: 4,
    icon: faScrewdriverWrench,
    title: "Retrofitting and Overhauling",
    body: "We provide timely online and on-site equipment service support, repairs and maintenance for all kinds of machines, with retrofitting and overhauling solutions that minimise component wear and maximise operational life.",
  },
];

export const qualityControl = [
  "Our quality control team conducts detailed First Article Inspections (FAI) to validate that initial samples conform to all specified design and functional criteria.",
  "Our metallurgical lab performs extensive material analysis, including spectrometry and microstructure examination, to verify alloy composition and structural integrity.",
  "A robust traceability system lets us track each component through its entire production cycle, ensuring full accountability.",
  "Our quality management system emphasises continuous improvement, using feedback loops and root cause analysis to rectify any quality issues promptly.",
];

export const vendorManagement = [
  "Our vendor selection process incorporates a detailed assessment of manufacturing capabilities, ensuring alignment with our quality and production standards.",
  "We use a comprehensive evaluation matrix to objectively assess potential suppliers, focusing on technical expertise, production capacity and financial stability.",
  "We conduct regular supplier audits using a structured checklist, covering process controls, traceability and corrective action implementation.",
  "We maintain a supplier requalification programme, periodically reassessing vendor capability and compliance as our standards evolve.",
];
